import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import TestPageActionTypes from './testPage.types';
import UtilsTypes from '../utilities/utils.types';
import { clearLocalStorage } from '../../utils/commonFunctions';
import ParentDashboardTypes from '../parentDashboard/parentDashboard.types';
import { getAttemptId, getQuestionId, getvideoId } from './testPage.selectors';
import Loader from '../../utils/Loader';
import { getChildToken } from '../parentDashboard/parentDashboard.selector';
import MyCourseActionTypes from '../myCourse/myCourse.types';
import { getUserType } from '../userAuthentication/userAuth.selectors';
import UserTypes from '../../utils/userTypes';
import { RPStart } from '../../utils/supervisor';
// import { mapOrgToDomain } from '../../utils/mapOrgToDomain';
function* setError(msg, showBtn = false) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({
			type: UtilsTypes.SET_ERROR_MSG, payload: msg,
			payloadBtn: showBtn,
		});
	}
	Loader.hide();
}

function* setAdminError(msg) {
	yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg, payloadBtn: true });
	yield put({
		type: TestPageActionTypes.TOGGLE_SUBMIT_ACTIVE,
		payload: { disableSubmit: true },
	});
	Loader.hide();
}

function* checkVideo() {
	try {
		let childToken = yield select(getChildToken);
		const attemptId = yield select(getAttemptId);
		const questionId = yield select(getQuestionId);
		const videoId = yield select(getvideoId);
		let userType = yield select(getUserType);
		const res = yield call(Api, {
			url: 'checkVideo',
			method: 'POST',
			data: {
				attempt_id: attemptId,
				question_id: questionId,
				videoURL: videoId,
			},
			headers: {
				'access-token':
					userType === UserTypes.Parent ? childToken : localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, res.message);
		} else {
			Loader.hide();
			if (res.code === 200) {
				yield call(setError, res.message);
			} else if (res.code === 204) {
				window.location.reload();
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('test page', err);
	}
}
function isDesktopDevice() {
	const ua = navigator.userAgent.toLowerCase();
	const isMobile = /android|iphone|ipad|ipod|mobile/i.test(ua);
	return !isMobile;
}

function* startAttempt({ payload: { courseId, elementId } }) {
	let childToken = yield select(getChildToken);
	let userType = yield select(getUserType);
	try {
		const res = yield call(Api, {
			url: 'startAttempt',
			method: 'POST',
			data: {
				course_id: courseId.toString(),
				element_id: elementId.toString(),
			},
			headers: {
				'access-token':
					userType === UserTypes.Parent ? childToken : localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, res.message);
		} else {
			if (res.code === 200) {
				localStorage.removeItem('resetCounter');
				localStorage.removeItem('resetCounters');
				Loader.hide();
				yield put({
					type: TestPageActionTypes.START_ATTEMPT.SUCCESS,
					payload: res.data.attempt,
				});

				try {
					const domain = "english";
					// const hostname = window.location.hostname;
					// const domain = hostname.split('.')[0];

					const orgId = localStorage.getItem('orgID');
					const loginId = localStorage.getItem('loginId');

					const proctorList = yield call(Api, {
						url: `get_proctor_details/${domain}/${courseId}/${orgId}`,
						method: 'GET',
					});

					const proctorElementIds = proctorList.map(item => item.element_id);
					localStorage.setItem('proctorList', JSON.stringify(proctorElementIds));

					const matched = proctorList?.find((item) => {
						return item.course_id == courseId &&
							item.element_id == elementId &&
							item.is_active == 1 &&
							(
								item.org_id == orgId || item.org_id == null
							);
					});
					if (matched) {
						if (isDesktopDevice()) {
							localStorage.setItem('proctorCourseId', courseId);
							RPStart({
								courseId,
								elementId,
								orgId,
								loginId,
								proctorEventName: matched.proctor_event_name,
							});
						} else {
							yield call(
								setError,
								'This test is not allowed to be taken on a mobile phone. Please use a desktop or laptop.',
								true
							);
							return;
						}
					}
				} catch (e) {
					console.log('Proctor skipped:', e);
				}

				if (!!courseId) {
					sessionStorage.setItem('activeSessionUnit', res.data.attempt.unit_id);
				}
				if (window.location.href.includes('/test')) {
					window.location.reload();
					yield put({
						type: TestPageActionTypes.SET_SHOW_THANK_YOU,
						payload: false,
					});
				} else {
					yield put(push('/test'));
				}
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('test page', err);
	}
}

function* fetchAttempt() {
	try {
		let childToken = yield select(getChildToken);
		const attemptId = yield select(getAttemptId);
		let userType = yield select(getUserType);
		const res = yield call(Api, {
			url: 'fetchattempt/' + attemptId,
			method: 'GET',
			headers: {
				'access-token':
					userType === UserTypes.Parent ? childToken : localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			yield put({ type: TestPageActionTypes.SET_SHOW_THANK_YOU, payload: false });
			if (res.code === 200) {
				Loader.hide();
				if (res.status !== 'success') {
					yield put(push('/mycourse'));
				}
				if (res.data.attempt.is_graded === 'Y') {
					yield put({ type: TestPageActionTypes.START_ATTEMPT.SUCCESS, payload: 0 });
					yield put(push('/mycourse'));
				}
				yield put({ type: TestPageActionTypes.SHOW_THANKYOU_MODAL });
				yield put({
					type: MyCourseActionTypes.SET_SHOW_TESTINSTRUCTION,
					payload: false,
				});
				yield put({
					type: TestPageActionTypes.FETCH_ATTEMPT.SUCCESS,
					payload: res.data,
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('test page', err);
	}
}

function* submitFeedback({ payload }) {
	try {
		let childToken = yield select(getChildToken);
		const attemptId = yield select(getAttemptId);
		const questionId = yield select(getQuestionId);
		let userType = yield select(getUserType);
		const res = yield call(Api, {
			url: 'questionFeedback',
			method: 'POST',
			data: {
				attempt_id: attemptId,
				question_id: questionId,
				feedback: payload,
			},
			headers: {
				'access-token':
					userType === UserTypes.Parent ? childToken : localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			Loader.hide();
			if (res.code === 200) {
				yield put({ type: TestPageActionTypes.SUBMIT_FEEDBACK.SUCCESS });
				window.location.reload();
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('test page', err);
	}
}

function* submitAnswer({ payload }) {
	try {
		let childToken = yield select(getChildToken);
		let userType = yield select(getUserType);
		const res = yield call(Api, {
			url: 'submitAnswer',
			method: 'POST',
			data: payload,
			headers: {
				'access-token':
					userType === UserTypes.Parent ? childToken : localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			Loader.hide();
			localStorage.setItem('isPauseTimer', false);
			localStorage.removeItem('resetCounter');
			localStorage.removeItem('resetCounters');
			if (res.code === 204) {
				yield put({
					type: TestPageActionTypes.SHOW_THANKYOU_MODAL,
					payload: res.data,
				});
				if (res.data.show_feedback.show_feedback !== 'Y') {
					yield put({ type: TestPageActionTypes.SET_SHOW_THANK_YOU, payload: true });
					if (!!childToken) {
						yield put({
							type: ParentDashboardTypes.GENERATE_CHILD_REPORT.PENDING,
							payload: true,
						});
					}
				} else {
					yield put({
						type: TestPageActionTypes.SUBMIT_ANSWER.SUCCESS,
						payload: res.data,
					});
				}
			} else if (res.code === 200) {
				if (!!res.data.next_question.length) {
					yield put({ type: TestPageActionTypes.SHOW_THANKYOU_MODAL });
					yield put({
						type: TestPageActionTypes.SUBMIT_ANSWER.SUCCESS,
						payload: res.data,
					});
				} else {
					// if (res.data.hasOwnProperty('message')) {
					if (res.data.message !== '') {
						yield call(setAdminError, res.data.message);
						return false
					}
					// }
					yield put({
						type: TestPageActionTypes.SHOW_THANKYOU_MODAL,
						payload: res.data,
					});
					if (res.data.show_feedback.show_feedback !== 'Y') {
						yield put({
							type: TestPageActionTypes.SET_SHOW_THANK_YOU,
							payload: true,
						});
						if (!!childToken) {
							yield put({
								type: ParentDashboardTypes.GENERATE_CHILD_REPORT.PENDING,
								payload: true,
							});
						}
					} else {
						yield put({
							type: TestPageActionTypes.SUBMIT_ANSWER.SUCCESS,
							payload: res.data,
						});
					}
				}
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('test page', err);
	}
}

function* submitFeedbackStart() {
	yield takeLatest(TestPageActionTypes.SUBMIT_FEEDBACK.PENDING, submitFeedback);
}

function* fetchAttemptStart() {
	yield takeLatest(TestPageActionTypes.FETCH_ATTEMPT.PENDING, fetchAttempt);
}

function* startAttemptStart() {
	yield takeLatest(TestPageActionTypes.START_ATTEMPT.PENDING, startAttempt);
}

function* checkVideoStart() {
	yield takeLatest(TestPageActionTypes.CHECK_VIDEO.PENDING, checkVideo);
}

function* submitAnswerStart() {
	yield takeLatest(TestPageActionTypes.SUBMIT_ANSWER.PENDING, submitAnswer);
}

export function* testPageSagas() {
	yield all([
		call(startAttemptStart),
		call(fetchAttemptStart),
		call(submitFeedbackStart),
		call(submitAnswerStart),
		call(checkVideoStart),
	]);
}